module.exports = __webpack_public_path__ + "static/img/pn-222.00c0605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pn-222.jpg
// module id = P37v
// module chunks = 1